import React from 'react'
import { useEffect, useRef } from 'react';
import { footerLinks } from '../constants'
import { Link } from 'react-router-dom'
import logo from "../../public/assets/images/logo1.png"
import { Facebook } from 'lucide-react';
import { Twitter } from 'lucide-react';
import { Instagram } from 'lucide-react';
import { Linkedin } from 'lucide-react';
import { motion } from 'framer-motion';
const Footer = () => {
  const navLists = [
   
    {
      name:"FAQs",
      path:"/faqs"
    }, 
    {
      name:"About",
      path:"/about"
    }, 
    {
      name:"Contact",
      path:"/contact"
    },
   
  ];

  const textRef = useRef();

  useEffect(() => {
    const navbarLogo = document.getElementById('navbar-logo');
    const footerLogo = document.getElementById('footer-logo');
    const links = document.querySelectorAll('.nav-link');
  
    // Rotate navbar logo on click
    const rotateLogoOnClick = () => {
      if (!navbarLogo) return;
      navbarLogo.classList.add('rotate-on-click');
      setTimeout(() => {
        navbarLogo.classList.remove('rotate-on-click');
      }, 600);
    };
  
    links.forEach(link => {
      link.addEventListener('click', rotateLogoOnClick);
    });
  
    // Footer animation observer
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          textRef.current?.classList.add('show-text');
          footerLogo?.classList.add('rotate-on-scroll');
        } else {
          textRef.current?.classList.remove('show-text');
          footerLogo?.classList.remove('rotate-on-scroll');
        }
      },
      { threshold: 0.5 }
    );
  
    if (textRef.current) observer.observe(textRef.current);
  
    return () => {
      links.forEach(link => link.removeEventListener('click', rotateLogoOnClick));
      if (textRef.current) observer.unobserve(textRef.current);
    };
  }, []);
  
  
  



  return (
    <footer className="py-5 sm:px-10 px-5 bg-slate-900 ">
      <div className="screen-max-width">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
    {/* Left Section: Logo */}
    <div className="flex-shrink-0">
    <Link className="nav-link" to="/">
  <div className="flex items-center justify-center h-28 space-x-2">
    {/* Logo on the left */}
    <motion.img
  src={logo}
  alt="InvestorRise Icon"
  className="w-16 h-14"
  id="footer-logo"
  initial={{ rotate: 0 }}
  whileInView={{ rotate: 360 }}
  transition={{ duration: 1, ease: "easeInOut" }}
  viewport={{ once: false, amount: 0.5 }} // triggers when 50% of it is in view
/>

    {/* Text block on the right */}
    <div className="flex flex-col leading-tight">
  <div className="flex text-xl font-normal tracking-wide space-x-1">
    <motion.span
      initial={{ x: -30, opacity: 0 }}
      whileInView={{ x: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
      viewport={{ once: false }}
      className="text-white font-medium"
    >
      ALI
    </motion.span>

    <motion.span
      initial={{ x: -30, opacity: 0 }}
      whileInView={{ x: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: "easeOut", delay: 0.6 }}
      viewport={{ once: false }}
      className="text-white font-medium"
    >
      CONSTRUCTIONS
    </motion.span>
  </div>



</div>
  </div>
</Link>


    </div>

    {/* Middle Section: Nav Links */}
    {navLists.map((nav) => (
    <div
      key={nav.name}
      className="text-xl flex flex-wrap justify-center font-semibold cursor-pointer text-slate-200 hover:text-teal-400 transition duration-300"
    >
      <Link to={nav.path} className="nav-link">
        {nav.name}
      </Link>
    </div>
  ))}








    {/* Right Section: Social Links */}
    <div className="flex gap-4 mt-10 md:mt-0 ">
                        <a href="#" className="hover:text-teal-500 transition-all">
                          <Facebook size={24} />
                        </a>
                        <a href="#" className="hover:text-teal-500 transition-all">
                          <Twitter size={24} />
                        </a>
                        <a href="#" className="hover:text-teal-500 transition-all">
                          <Instagram size={24} />
                        </a>
                        <a href="#" className="hover:text-teal-500 transition-all">
                          <Linkedin size={24} />
                        </a>
                      </div>
  </div>

  {/* Optional Bottom Text */}
  {/* <div className="mt-6 text-center text-xs text-gray-400">
    <p className="mb-1">
      More ways to shop:{' '}
      <span className="underline text-blue-400 cursor-pointer">Find a Store</span> or{' '}
      <span className="underline text-blue-400 cursor-pointer">other retailer</span> near you.
    </p>
    <p>Or call 000800-040-1966</p>
  </div> */}

        <div className="bg-neutral-700 my-5 h-[1px] w-full" />

        <div className="flex md:flex-row flex-col md:items-center justify-between md:py-10">
          <p className="font-normal text-gray text-sm">© Copyright 2025 Ali Constructions. All rights reserved.</p>
          <div className="flex">
           
              <p  className="font-normal text-gray text-sm">
                Ali Constructions{' '}
             
                  <span className="mx-2"> | </span>
             
              </p>
              <Link to="/" >
              <p  className="font-normal text-gray text-sm hover:text-teal-400 transition-all">
                Privacy Policy{' '}
            
                 
             
              </p> </Link>
              <span className="mx-2  text-gray text-sm"> | </span>
              <p  className="font-normal text-gray text-sm ">
                Developed by <a href="https://www.haitchverse.com" className='hover:text-teal-400'>Haitchverse</a>{' '}
             
                  {/* <span className="mx-2"> | </span> */}
             
              </p>
        
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer